/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { IContainsDictionariesRemoteDto } from "./i-contains-dictionaries-remote-dto";
import { IRemoteDto } from "./i-remote-dto";
import { ConversationTypeRemoteDto } from "./conversation-type-remote-dto";
import { CallInformationRemoteDto } from "./call-information-remote-dto";

export class SamwinCallInfoRemoteDto implements IContainsDictionariesRemoteDto, IRemoteDto {
    dictionaryProperties: string[] = ["Tags"];
    callId: number;
    peerId: string;
    peerName: string;
    timestamp: Date;
    waitingSince: Date;
    queueId: number;
    queueIdOpExt: number;
    skillValue: number;
    info: string;
    messageId: string;
    subject: string;
    type: ConversationTypeRemoteDto;
    assignedUserId: number;
    ici: CallInformationRemoteDto;
    tags: { [key: string]: string; };
}
